import React from 'react';

import DnsRecordsListForm from './DnsRecordsListForm';
import EmailDomain from 'src/models/Email/EmailDomain';
import EmbedModalWithGreenHeader from 'src/presentation/components/pages/shared/EmbedModalWithGreenHeader';
import { ModalSize } from 'src/presentation/components/pages/shared/EmbedModal';
import { STATUS_SUCCEEDED } from 'src/presentation/hooks/useResource';
import { StepContainer } from './StepWizardLayout';

type DnsRecordsModalModalType = {
  handleCloseModal: () => void;
  item: EmailDomain | null;
};

export default function DnsRecordsModalModal({ handleCloseModal, item }: DnsRecordsModalModalType) {
  const getModalContent = () => (
    <StepContainer dataAid="dns-records-table">
      <DnsRecordsListForm
        item={item}
        onNextButtonClick={handleCloseModal}
        nextButtonName="Done"
        loadingState={STATUS_SUCCEEDED}
      />
    </StepContainer>
  );

  return (
    <EmbedModalWithGreenHeader
      data-aid="new-email-domain"
      title="View SPF and DKIM values"
      modalSize={ModalSize.LARGE}
      content={getModalContent()}
      onCancel={handleCloseModal}
    />
  );
}
